import React from "react"
import style from "./fees.module.scss"
import leaf_png from "./img/leaf.png"
import leaf3_png from "./img/leaf3.png"
import time from "./img/time.png"

function Fees() {
  return (
    <div className={`${style.fees} container`}>
      <h3 className={style.fees__title}>Service Fees</h3>
      <div className={style.fees__body}>

        <div className={style.fees__content}>
          <img className={style.fees__leaf} src={leaf_png} alt="leaf tree" width="63px" height="79px"/>
          <div className={style.fees__contentTitle}>
            <h4>Acupuncture</h4>
          </div>
          <div className={style.fees__contentBodyFlex}>
            <div>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$145</span> for Initial
              </p>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$100</span> for Follow-up
              </p>
            </div>
            <div>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 90 min</p>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 60 min</p>
            </div>
          </div>
        </div>

        <div className={style.fees__content}>
          <div className={style.fees__contentTitle}>
            <h4>Laser Therapy</h4>
          </div>
          <div className={style.fees__contentBody}>
            <p className={style.fees__contentText}><span className={style.fees__contentBold}>Free</span> with
              acupuncture treatment</p>
            <p className={style.fees__contentText}><span className={style.fees__contentBold}>$20</span> individual
              session</p>
          </div>
        </div>

        <div className={style.fees__content}>
          <img className={style.fees__leaf3} src={leaf3_png} alt="leaf tree" width="81px" height="89px"/>

          <div className={style.fees__contentTitle}>
            <h4>Pediatric Visit</h4>
          </div>
          <div className={style.fees__contentBody}>
            <p className={style.fees__contentBold}>$60</p>
          </div>
        </div>

        <div className={style.fees__content}>
          <div className={style.fees__contentTitle}>
            <h4>Infrared sauna</h4>
          </div>
          <div className={style.fees__contentBodyFlex}>
            <div>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$30</span></p>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$45</span></p>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$60</span></p>
            </div>
            <div>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 30 min</p>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 45 min</p>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 60 min</p>
            </div>
          </div>
        </div>

        <div className={style.fees__content}>
          <div className={style.fees__contentTitle}>
            <h4>Herbal Consult </h4>
            <h5 className={style.fees__contentTitleLow}>with Acupuncture</h5>
          </div>
          <div className={style.fees__contentBodyFlex}>
            <div>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$30</span> for Initial
              </p>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$15</span> for Follow-up
              </p>
            </div>
            <div>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 30 min</p>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 15 min</p>
            </div>
          </div>
        </div>

        <div className={style.fees__content}>
          <div className={style.fees__contentTitle}>
            <h4>Herbal Consult </h4>
            <h5 className={style.fees__contentTitleLow}>without Acupuncture</h5>
          </div>
          <div className={style.fees__contentBodyFlex}>
            <div>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$70</span> for Initial
              </p>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$40</span> for Follow-up
              </p>
            </div>
            <div>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 30 min</p>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 15 min</p>
            </div>
          </div>
        </div>

        <div className={style.fees__content}>
          <div className={style.fees__contentTitle}>
            <h4>Community Acupuncture</h4>
          </div>
          <div className={style.fees__contentBodyFlex}>
            <div>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$25-$45</span>
                sliding scale</p>
              <p className={style.fees__contentText}><span className={style.fees__contentBold}>$220</span> for 10 visits</p>
            </div>
            <div>
              <p className={style.fees__contentText}><img src={time} alt="time" width="17px" height="18px"/> 45 min</p>
              <p className={style.fees__contentText}>&nbsp;</p>
            </div>
          </div>
        </div>


      </div>
    </div>
  )
}

export default Fees